import { fetchInitialPermissions } from '@/api/users'
import { type UserPermissions } from '@/api/users/types'
import { useSpaces } from './use-spaces'

export const useUserPermissions = createGlobalState(() => {
  const permissions = ref<UserPermissions>({
    can_edit: false,
    can_search_jira: false,
    is_admin: false,
    is_reviewer: false,
    is_ambassador: false,
    is_ambassador_plus: false,
  })
  const isLoading = ref(false)
  const { setSpaces } = useSpaces()

  async function fetchPermissions() {
    isLoading.value = true
    const { spaces, ...initialPermissions } = await fetchInitialPermissions()
    permissions.value = initialPermissions
    setSpaces(spaces)
    isLoading.value = false
  }

  return {
    fetchPermissions,
    permissions,
    isLoading,
  }
})
